module.exports = __webpack_public_path__ + "img/protocol-logo.6ffea737.png";